// src/components/analytics/Charts/SegmentationChart.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Cell } from 'recharts';

function SegmentationChart({ data }) {
  if (!data) return null;

  const chartData = [
    { name: 'VIP', customers: data.vip_customers || 0, color: '#8b5cf6' },
    { name: 'Loyal', customers: data.loyal_customers || 0, color: '#10b981' },
    { name: 'Potential', customers: data.potential_customers || 0, color: '#3b82f6' },
    { name: 'At Risk', customers: data.at_risk_customers || 0, color: '#f59e0b' },
    { name: 'Inactive', customers: data.inactive_customers || 0, color: '#ef4444' }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{payload[0].payload.name} Customers</p>
          <p className="value">{payload[0].value} customers</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="segmentation-chart-container">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="customers" fill="#3b82f6">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SegmentationChart;
